import { forwardRef } from 'react';
import { Badge, IconButton, styled } from 'shell/components';

const FeedbackRegenerationAction = forwardRef(({ count = 0, disabled, ...rest }, ref) => {
    return (
        <CountBadge badgeContent={count} invisible={!count} max={99}>
            <IconButton ref={ref} {...rest} disabled={disabled} kind={'ai'} size={'medium'} variant={'square'} />
        </CountBadge>
    );
});

const CountBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        top: '3px',
        right: '2px',
        minWidth: '14px',
        height: '14px',
        padding: 0,
        background: theme.palette.ensightful.primary[500],
        color: theme.palette.ensightful.shades[0],
        fontSize: '0.5rem',
        lineHeight: 1,
    },
}));

export default FeedbackRegenerationAction;
